// extracted by mini-css-extract-plugin
export default {"urlBlock":"UrlBlock_urlBlock__ePVSX","box":"UrlBlock_box__BX0oJ","url":"UrlBlock_url__Pkyhm","copyButton":"UrlBlock_copyButton__+FZh0","viewButton":"UrlBlock_viewButton__Tf8Da"};